import { StrictNullable } from '@/shared/types/app.types'
import { GridItemData } from 'vue-grid-layout'

export enum DashboardModuleSection {
    ALL = 'ALL',
    CLINICAL = 'CLINICAL',
    REQUEST = 'REQUEST',
    REGISTRY = 'REGISTRY',
    GROSSING = 'GROSSING',
    WASTE = 'WASTE',
    INCIDENTS = 'INCIDENTS',
    OTHERS = 'OTHERS',
    DIAGNOSIS = 'DIAGNOSIS',
    LABORATORY = 'LABORATORY'
}

export enum DashboardModuleArea {
    PENDING_ELEMENTS = 'PENDING_ELEMENTS',
    CHARTS = 'CHARTS',
    INTEREST_DATA = 'INTEREST_DATA',
    UTILITIES = 'UTILITIES'
}

export enum DashboardModuleWidgetOption {
    REQUESTS_WITH_REPORT_NOT_READ = 'requestsWithReportNotRead',
    REQUESTS_WITH_AP_REPORT_NOT_SEEN = 'requestsWithApReportNotSeen',
    REQUESTS_WITH_ISSUE = 'requestsWithIssue',
    LOCKED_REQUESTS = 'requestsInLockState',
    REGISTRY_REQUESTED = 'registryRequested',
    REGISTRY_REQUESTS_LOCKED = 'registryRequestsLocked',
    REGISTRY_TODAY = 'registryToday',
    FOR_GROSSING = 'forGrossing',
    FOR_REGROSSING = 'forRegrossing',
    GROSSING_TODAY = 'grossingToday',
    PENDING_DISPOSAL = 'toBeDiscarded',
    WASTE_TODAY = 'wasteToday',
    OPENED_INCIDENTS = 'stillOpenAndOpenedByMe',
    PORTION_MAKE = 'operation.entity.portion.make',
    PORTION_CUT = 'operation.entity.portion.cut',
    SUBPORTION_TO_SCANNER = 'operation.entity.subportion.to-scanner',
    SUBPORTION_SCAN = 'operation.entity.subportion.scan',
}

export enum DashboardModuleLayoutWidgetRenderComponent {
    PENDING_WIDGET = 'dashboard-module-shared-widgets-pending-widget',
    NEW_CASE_WIDGET = 'dashboard-module-shared-widgets-new-case-widget',
    PRINT_LABELS = 'dashboard-module-shared-widgets-print-labels-widget'
}

export enum DashboardModuleLayoutWidgetWidgetLink {
    NEW_CASE = 'newCase',
    NEW_REQUEST = 'newRequest',
    CLINICAL_GRID = 'clinicalGrid',
    REQUEST_GRID = 'requestGrid',
    CASE_GRID = 'caseGrid',
    GROSSING_GRID = 'grossingGrid',
    WASTE_GRID = 'wasteGrid',
    INCIDENTS_MODULE = 'incidentsModule',
    LABORATORY_MODULE = 'laboratoryModule'
}

export enum DashboardModuleLayoutWidgetSubType {
    CASE = 'case',
    REQUEST = 'request'
}

export interface DashboardModuleLayoutWidget{
    id: string
    area: DashboardModuleArea
    section: DashboardModuleSection
    renderComponent: DashboardModuleLayoutWidgetRenderComponent
    label: string
    moduleLabel: string
    hidden: boolean
    disabled: boolean
    coordinates: StrictNullable<GridItemData>
    subType?: DashboardModuleLayoutWidgetSubType
    // scope?: string
    // prelabel?: string
    color?: string
    icon?: string
    widgetLink?: DashboardModuleLayoutWidgetWidgetLink
    widgetOption?: DashboardModuleWidgetOption
    // uiComponent?: string
    width: number
    height: number
}

export interface DashboardModuleSectionsWidgets {
    id: DashboardModuleSection
    text: string
}

export interface DashboardModuleUIComponentState {
    pendingArea: DashboardModuleLayoutWidget[]
    chartArea: DashboardModuleLayoutWidget[]
    interestingDataArea: DashboardModuleLayoutWidget[]
    utilitiesArea: DashboardModuleLayoutWidget[]
}

export interface DashboardModuleZoneAreaOptions {
    isWidgetFillToWidth?: boolean
    isWidgetFillToHeight?: boolean
}

export interface DashboardModuleZoneArea {
    id: string
    area: DashboardModuleArea
    options: DashboardModuleZoneAreaOptions
}

export const dashboardModuleGridMaxCols = 4

export enum DashboardModuleSummaryType {
    VIEW_ALL = 'VIEW_ALL',
    MINE = 'MINE'
}
